import React, {Component} from "react";
import {Box, Grid, Typography} from '@deere/fuel-react';
import {List, Dropdown} from "@deere/ux.uxframe-react";

import {MAX_RESULT_PER_PAGE} from "../shared/Constants";
import {Loading} from "../shared/Loading";
import PaginationData from "../shared/PaginationData";
import {NoData} from "../shared/NoData";

class CriteriaList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            total: 0,
            perPage: MAX_RESULT_PER_PAGE,
            selectedOption: "Category A-Z",
            listToShow: [],
            isLoading: true
        };
    }

    updateComponent() {
        this.setState({
            total: this.props.list.length,
            listToShow: [].sort.call(this.props.list, function (x, y) {
                return x.props.criteria.category.description.localeCompare(y.props.criteria.category.description);
            }),
            page: 1,
            perPage: MAX_RESULT_PER_PAGE,
            selectedOption: "Category A-Z",
            isLoading: false
        });
    }

    componentDidMount() {
        if (!!this.props?.list) {
            this.updateComponent()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list) {
            this.updateComponent()
        }
    }

    setSortingOption(sortMethod) {
        this.setState({selectedOption: sortMethod}, () => {
            this.sortData()
        });
    }

    sortData = () => {
        if (this.state.selectedOption === "Category A-Z")
            this.setState({
                listToShow: [].sort.call(this.state.listToShow, function (x, y) {
                    return x.props.criteria.category.description.localeCompare(y.props.criteria.category.description);
                }),
            });
        else if (this.state.selectedOption === "Category Z-A")
            this.setState({
                listToShow: [].sort.call(this.state.listToShow, function (x, y) {
                    return y.props.criteria.category.description.localeCompare(x.props.criteria.category.description);
                }),
            });

        this.setState({page: 1}); // Resetting page to 1
    };

    getEventHandler = (data) => {
        this.setState({page: data.page});
    }

    render() {
        const pageData = {
            page: this.state.page,
            total: this.state.total,
            perPage: this.state.perPage
        }
        const eventHandler = data => {
            this.getEventHandler(data)
        };
        const {total, page, perPage, isLoading} = this.state;
        const noDataMessage = {
            textLine1: "No results found. Please try a new search term or expanding your filter criteria."
        }
        return (
            <>
                {total > 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            <Box display="flex" p={2} justifyContent="flex-start">
                                <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                                    {total} Results
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box display="flex" p={2} justifyContent="flex-end">
                                <Typography size="md" fontWeight="bold" component="p"
                                            style={{paddingRight: 10, paddingTop: 2}}>
                                    Sort By
                                </Typography>
                                <Dropdown>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic-3" style={{padding: 0}}>
                                        {this.state.selectedOption}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => {
                                                this.setSortingOption("Category A-Z");
                                            }}
                                        >
                                            Category A-Z
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                this.setSortingOption("Category Z-A");
                                            }}
                                        >
                                            Category Z-A
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Box>
                        </Grid>
                        {/*<Grid item xs={5}>*/}
                        {/*    <Box display="flex" p={1} justifyContent="flex-end">*/}

                        {/*    </Box>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={3}>*/}
                        {/*    <Box display="flex" justifyContent="flex-end">*/}
                        {/*        <ToggleButtonGroup role="toolbar" name="radioButtonGroup" type="radio" defaultValue={1}*/}
                        {/*                           ariaLabel="Basic button toggle example">*/}
                        {/*            <ToggleButton value={1}><ListIcon/>List</ToggleButton>*/}
                        {/*            <ToggleButton value={2}><TableChartIcon/>Table</ToggleButton>*/}
                        {/*        </ToggleButtonGroup>*/}
                        {/*    </Box>*/}
                        {/*</Grid>*/}
                    </Grid>
                )}
                {!isLoading && (
                    <List className="list-group">
                        {this.state.listToShow && this.state.listToShow.slice(
                            (page - 1) * perPage,
                            (page - 1) * perPage + perPage
                        )}
                    </List>
                )}
                {!isLoading && this.state.listToShow && this.state.listToShow.length === 0 && (
                    <NoData noDataMessage={noDataMessage}/>
                )}

                {isLoading && (
                    <Loading/>
                )}

                {total > MAX_RESULT_PER_PAGE && (
                    <PaginationData pageData={pageData} onChange={eventHandler}/>
                )}
            </>
        );
    }
}

export default CriteriaList;
